module.exports = __webpack_public_path__ + "img/desktop-preview.604c9ad2.jpg";